import * as React from 'react';

import { TextField } from '@coursera/cds-core';

import _t from 'i18n!nls/account-profile';

const MAX_INSTITUTION_LENGTH = 100;

type DropdownProps = {
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
};

const UniversityTextField = ({ value, onChange, errorMessage }: DropdownProps) => {
  return (
    <TextField
      aria-label={_t('Name of institution')}
      placeholder={_t('Enter institution name')}
      inputProps={{ required: false }}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth
      maxLength={MAX_INSTITUTION_LENGTH}
      characterLimit={MAX_INSTITUTION_LENGTH}
      validationStatus={errorMessage ? 'error' : undefined}
      validationLabel={errorMessage}
    />
  );
};

export default UniversityTextField;
